import { useEffect, type ReactNode } from 'react';
import useThemeStore from '../../store/themeStore';
import { getThemeById } from '../../constants/themes';

interface ThemeProviderProps {
    children: ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
    const { themeId } = useThemeStore();

    useEffect(() => {
        // Apply theme on mount and when themeId changes
        const theme = getThemeById(themeId);
        const root = document.documentElement;

        root.style.setProperty('--color-primary', theme.colors.primary);
        root.style.setProperty('--color-secondary', theme.colors.secondary);
        root.style.setProperty('--color-accent', theme.colors.accent);
        root.style.setProperty('--color-background', theme.colors.background);
        root.style.setProperty('--color-surface', theme.colors.surface);
        root.style.setProperty('--color-text', theme.colors.text);
        root.style.setProperty('--color-text-muted', theme.colors.textMuted);
        root.style.setProperty('--gradient-from', theme.gradient.from);
        root.style.setProperty('--gradient-via', theme.gradient.via);
        root.style.setProperty('--gradient-to', theme.gradient.to);
    }, [themeId]);

    return <>{children}</>;
};

export default ThemeProvider;
